import { getOwner } from "@ember/application"
import { action, get } from "@ember/object"
import Route from "@ember/routing/route"
import { scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"

export default class SetupRoute extends Route {
  @service("ember-store")
  store

  lastRouteVisited = null

  @action
  didTransition() {
    // BLOGGABLE TRICK
    scheduleOnce("afterRender", () => {
      let applicationController = getOwner(this).lookup("controller:application")
      let currentRouteName = get(applicationController, "currentRouteName")
      if (currentRouteName === "planbook.setup.index") {
        if (this.lastRouteVisited === null) this.lastRouteVisited = "planbook.setup.classes"
        this.replaceWith(this.lastRouteVisited)
      } else {
        this.lastRouteVisited = currentRouteName
      }
    })
  }
}
